export default "__VITE_ASSET__BFiHDSD9__"